export default socket => ({
    authenticate: data => {
        console.tron.log('SOCKET EMMIT - authentication')
        console.tron.log(data)
        socket.emit('authentication', data)
    },
    getMyUser: () => {
        console.tron.log('SOCKET EMMIT - request_my_user')
        socket.emit('request_my_user')
    },
})



// WEBPACK FOOTER //
// src/api/emitters/auth.js